import React from "react";
import { Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import useDocumentTitle from "../hooks/useDocumentTitle";

export default function NotFound() {
    useDocumentTitle("404 - Page Not Found | JSONHelper.io");
  return (
    <Container style={{ paddingTop: "80px", paddingBottom: "80px", textAlign: "center" }}>
      <h1>404 - Page Not Found</h1>

      <p style={{ marginTop: "20px", maxWidth: "600px", marginInline: "auto" }}>
        The page you’re looking for doesn’t exist or may have been moved.
        JSONHelper helps you visualize and explore JSON data easily.
      </p>

      <div style={{ marginTop: "30px" }}>
        <Link to="/">
          <Button variant="primary" style={{ marginRight: "10px" }}>
            Go to Homepage
          </Button>
        </Link>

        <Link to="/tool">
          <Button variant="outline-secondary">
            Open JSON Tool
          </Button>
        </Link>
      </div>
    </Container>
  );
}